import React from 'react';

import { formatLargeNumber, mString } from 'lib/helpers/utility';

const remittancesText = (count) =>
  `${formatLargeNumber(count)} remittance${Number(count) === 1 ? '' : 's'}`;

// A Payer Rules decision: what rule it was and what it changed. Read-only — there is no screen
// behind it to open. An enacted rule reads like any other amount change in the log.
const IncomeIQueuePayerRuleDetail = ({ activity }) => {
  const rule = activity?.metadata || {};
  const isEnacted = activity?.action === 'payer_rule_enacted';
  const subject = [rule.payer_name, rule.code].filter(Boolean).join(' · ') || 'Payer rule';

  return (
    <div className="pl-[9px]">
      <div className="flex flex-col gap-1 border-0 border-l border-solid border-neutral-300 pl-[13px]">
        <p className="text-sm font-semibold leading-[22px] text-neutral-800">{subject}</p>
        {isEnacted ? (
          <div className="flex flex-wrap items-center gap-1 text-sm leading-[22px]">
            <span className="font-semibold text-neutral-800">Expected allowable amount</span>
            <span className="font-500 text-neutral-500">from</span>
            <span className="font-500 text-neutral-500">{mString(rule.gfe_amount)}</span>
            <span className="font-500 text-neutral-500">to</span>
            <span className="font-semibold text-neutral-800">{mString(rule.final_amount)}</span>
          </div>
        ) : (
          <p className="text-sm leading-[22px] text-neutral-600">
            {`Kept ${mString(rule.gfe_amount)}; the payer allowed ${mString(rule.final_amount)}`}
          </p>
        )}
        {!!rule.detections && (
          <p className="text-xs leading-[18px] text-neutral-500">
            {`Based on ${remittancesText(rule.detections)}`}
          </p>
        )}
      </div>
    </div>
  );
};

export default IncomeIQueuePayerRuleDetail;
